/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './referral.reducer';

export const ReferralDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const referralEntity = useAppSelector(state => state.referral.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="referralDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.referral.detail.title">Referral</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.referral.id">Id</Translate>
            </span>
          </dt>
          <dd>{referralEntity.id}</dd>
          <dt>
            <span id="referralTypeCode">
              <Translate contentKey="tinyMedicRestApp.referral.referralTypeCode">Referral Type Code</Translate>
            </span>
          </dt>
          <dd>{referralEntity.referralTypeCode}</dd>
          <dt>
            <span id="referralName">
              <Translate contentKey="tinyMedicRestApp.referral.referralName">Referral Name</Translate>
            </span>
          </dt>
          <dd>{referralEntity.referralName}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.referral.active">Active</Translate>
            </span>
          </dt>
          <dd>{referralEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.referral.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{referralEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.referral.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{referralEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.referral.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{referralEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.referral.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{referralEntity.cursor}</dd>
          <dt>
            <span id="served">
              <Translate contentKey="tinyMedicRestApp.referral.served">Served</Translate>
            </span>
          </dt>
          <dd>{referralEntity.served ? 'true' : 'false'}</dd>
          <dt>
            <span id="referralNotes">
              <Translate contentKey="tinyMedicRestApp.referral.referralNotes">Referral Notes</Translate>
            </span>
          </dt>
          <dd>{referralEntity.referralNotes}</dd>
          <dt>
            <span id="accepted">
              <Translate contentKey="tinyMedicRestApp.referral.accepted">Accepted</Translate>
            </span>
          </dt>
          <dd>{referralEntity.accepted ? 'true' : 'false'}</dd>
          <dt>
            <span id="rejected">
              <Translate contentKey="tinyMedicRestApp.referral.rejected">Rejected</Translate>
            </span>
          </dt>
          <dd>{referralEntity.rejected ? 'true' : 'false'}</dd>
          <dt>
            <span id="rejectNotes">
              <Translate contentKey="tinyMedicRestApp.referral.rejectNotes">Reject Notes</Translate>
            </span>
          </dt>
          <dd>{referralEntity.rejectNotes}</dd>
          <dt>
            <span id="patientType">
              <Translate contentKey="tinyMedicRestApp.referral.patientType">Patient Type</Translate>
            </span>
          </dt>
          <dd>{referralEntity.patientType}</dd>
          <dt>
            <span id="exposed">
              <Translate contentKey="tinyMedicRestApp.referral.exposed">Exposed</Translate>
            </span>
          </dt>
          <dd>{referralEntity.exposed ? 'true' : 'false'}</dd>
          <dt>
            <span id="sourceAppointmentId">
              <Translate contentKey="tinyMedicRestApp.referral.sourceAppointmentId">Source Appointment Id</Translate>
            </span>
          </dt>
          <dd>{referralEntity.sourceAppointmentId}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.referral.admission">Admission</Translate>
          </dt>
          <dd>{referralEntity.admission ? referralEntity.admission.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.referral.referredTo">Referred To</Translate>
          </dt>
          <dd>{referralEntity.referredTo ? referralEntity.referredTo.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.referral.referredBy">Referred By</Translate>
          </dt>
          <dd>{referralEntity.referredBy ? referralEntity.referredBy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.referral.glucoUser">Gluco User</Translate>
          </dt>
          <dd>{referralEntity.glucoUser ? referralEntity.glucoUser.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/referral" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/referral/${referralEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ReferralDetail;
